export enum PlanoStatus {
  ATIVO = 'ATIVO',
  INATIVO = 'INATIVO',
  RASCUNHO = 'RASCUNHO',
  EXPIRADO = 'EXPIRADO',
}
